import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm} from 'redux-form';

import {required, validEmail} from 'utils/validators';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {TextField} from 'components/Fields';
import ErrorBlock from 'components/ErrorBlock';

import {selectModal} from 'ducks/modals';
import {MODALS, inviteNewStaffMember} from 'ducks/teams';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  dispatch(
    inviteNewStaffMember(
      {...values, teams: [props.teamId]},
      props.submitExtraActions
    )
  );
};

class InviteNewTeamMemberForm extends React.Component<any> {
  render() {
    const {error} = this.props;

    return (
      <form
        className="InviteNewTeamMemberForm"
        onSubmit={this.props.handleSubmit}>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>Name</Label>
          <Field
            name="name"
            component={TextField}
            placeholder="How do you want their name to appear?"
            validate={[required]}
          />
        </FormField>
        <FormField>
          <Label>Email</Label>
          <Field
            name="email"
            component={TextField}
            placeholder="First letter then surname @thecollective.co.uk"
            validate={[required, validEmail]}
          />
        </FormField>
        <FormField>
          <Label>Job Title</Label>
          <Field
            name="jobTitle"
            component={TextField}
            placeholder="What is their job title within the company?"
            validate={[required]}
          />
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const {data: {teamId}} = selectModal(state, MODALS.INVITE_NEW_TEAM_MEMBER);

  return {teamId};
};

/*
`inviteNewStaffMember` is used also for the `InviteNewStaffMemberForm` when connecting it to the store.
This duplication is made on purpose because:
   1) The forms will never be mounted together in the same time
   2) Both of the forms use the same ducks
*/
export default connect(mapStateToProps)(
  reduxForm({
    form: 'inviteNewStaffMember',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(InviteNewTeamMemberForm)
);
